import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import DateTime from '_class/DateTime';

var FromNow = /*#__PURE__*/function (_Component) {
  _inherits(FromNow, _Component);

  var _super = _createSuper(FromNow);

  function FromNow() {
    var _this;

    _classCallCheck(this, FromNow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "formatDate", function () {
      var dateTime = new DateTime(_this.props.children);

      if (_this.props.utc) {
        return _this.capitalizeFirstLetter(dateTime.getFromNow());
      }

      return _this.capitalizeFirstLetter(dateTime.getFromNow());
    });

    return _this;
  }

  _createClass(FromNow, [{
    key: "icon",
    value: function icon() {
      return /*#__PURE__*/React.createElement("svg", {
        id: "Lager_1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        xmlSpace: "preserve",
        viewBox: "0 0 12 12"
      }, /*#__PURE__*/React.createElement("style", {
        type: "text/css"
      }, '.st0{fill:none;stroke:#1D1D1B;stroke-width:1.2756;stroke-linecap:round;stroke-miterlimit:10;}'), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
        className: "st0",
        cx: "6",
        cy: "6.7",
        r: "4.4"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "6",
        y1: "3.9",
        x2: "6",
        y2: "6.7"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "6",
        y1: "2.1",
        x2: "6",
        y2: "1.1"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "5.1",
        y1: "0.8",
        x2: "6.9",
        y2: "0.8"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "6",
        y1: "6.7",
        x2: "7.3",
        y2: "5.6"
      }), /*#__PURE__*/React.createElement("line", {
        className: "st0",
        x1: "9.4",
        y1: "3.8",
        x2: "10.1",
        y2: "3.2"
      })));
    }
  }, {
    key: "capitalizeFirstLetter",
    value: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }, {
    key: "render",
    value: function render() {
      var containerProps = _objectSpread({}, this.props);

      delete containerProps.children;
      delete containerProps.dateTime;
      return /*#__PURE__*/React.createElement("time", _extends({
        className: "from-now card-meta",
        dateTime: this.props.children
      }, containerProps), this.icon(), this.formatDate());
    }
  }]);

  return FromNow;
}(Component);

export default FromNow;